import React from 'react';
import './BookingBar.css';

const guestOptions = [1,2,3,4,5,6,7,8];

const GuestPickerModal = ({ open, onClose, onSelect, selectedGuest }) => {
  if (!open) return null;
  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div className="payment-modal" style={{width: 350, maxWidth: '90vw', padding: 32}} onClick={e => e.stopPropagation()}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 16}}>
          <h3 style={{margin:0}}>Guests</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div style={{display:'flex', flexWrap:'wrap', gap:16, justifyContent:'center'}}>
          {guestOptions.map(opt => (
            <button
              key={opt}
              className="dropdown-item"
              style={{
                minWidth: 60,
                minHeight: 60,
                fontSize: 22,
                borderRadius: 12,
                border: opt===selectedGuest ? '2px solid #222' : '1px solid #eee',
                background: opt===selectedGuest ? '#f5f5f5' : '#fff',
                fontWeight: opt===selectedGuest ? 'bold' : 'normal',
                transition: 'all 0.2s',
              }}
              onClick={() => {onSelect(opt); onClose();}}
            >{opt}</button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GuestPickerModal; 